import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import EditButtonSectionModal from "../../editbutton.component.jsx"

class LineSeparatorContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
        this.showEdition = this.showEdition.bind(this)
        this.hideEdition = this.hideEdition.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    showEdition() {
        if (this.state.editable) {
            this.setState({
                edition: true,
            })
        }
    }

    hideEdition() {
        if (this.state.editable) {
            this.setState({
                edition: false,
            })
        }
    }

    render() {
        if (!this.state.section) {
            return <div />
        }
        return (
            <div className={'row'} id={this.state.id}>
                <EditButtonSectionModal
                    onMouseEnter={this.showEdition}
                    onMouseLeave={this.hideEdition}
                    sectionId={this.state.section.id}
                    documentId={this.state.section.attributes.documentId}
                    onClose={this.state.onEdit}
                    editable={this.state.editable}
                    marginTop={'-45px'}
                    icon={'arrows-alt-v'}
                    variables={this.state.variables}
                />
            </div>
        );
    }
}

export default LineSeparatorContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/empty-space/section.component.jsx